import { Show, Match, Switch } from 'solid-js';
import {DateTime} from 'luxon';
import { dateTitleText, daysOfWeekly, weekday, cleanTime } from 'Shared/common/Macros';


export function DateTitle(P)
{
	return (
		<>
			{dateTitleText(P.frequency,P.startSingle,P.startTime,P.allDay,P.weekdays,P.days,
				P.week,P.weekday)}
		</>
	);
}


export function DateTitleWithEndTimes(P)
{
	return (
		<Switch>
			<Match when={P.frequency == 'once'}>
				<Show when={P.startSingle}>
					{ DateTime.fromISO(P.startSingle).toFormat('EEE, dd LLL') }
					<StartTime time={P.startSingle} />
				</Show>
				<Show when={P.endSingle} fallback=' until close'>
					{' '}
					until {cleanTime(P.endSingle)}
				</Show>
			</Match>
			<Match when={P.frequency == 'daily'}>
				Every Day
				<StartTime time={P.startTime} allDay={P.allDay} />
			</Match>
			<Match when={P.frequency == 'weekly'}>
				{daysOfWeekly(P.weekdays)}
				{' '}
				{P.days}
				<StartTime time={P.startTime} allDay={P.allDay} />

				<Show when={P.endTime} fallback=' until close'>
					{' '}
					until {cleanTime(P.endTime)}
				</Show>
			</Match>
			<Match when={P.frequency == 'monthly'}>
				{P.week}
				{' '}
				{weekday(P.weekday)} of month

				<StartTime time={P.startTime} allDay={P.allDay} separator=', ' />

				<Show when={P.endSingle} fallback=' until close'>
					{' '}
					until {cleanTime(P.endSingle)}
				</Show>
			</Match>
		</Switch>
	);
}

function StartTime(P)
{
	return (
		<Show when={P.time && !P.allDay}>
			{P.separator ??  ' '}
			{cleanTime(P.time)}
		</Show>
	);
}
